import styled from "styled-components";
import { TextRegular } from './../../styles/GlobalStyledComponents';

export const ContinuationContainer = styled.div`
`;

export const ContinuationText = styled.div``;

export const ContinuationStepsRow = styled.div`
    display: flex;
    justify-content: space-around;
    margin: 20px 0;
`;

export const ContinuationStep = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
`;

export const ContinuationImg = styled.img`
    /* width: 100%; */
`;

export const VerticalLine = styled.div`
    border-right: 1px solid #e1eaf1;
`;

export const ReminderText = styled(TextRegular)`
    text-align: center;
    margin-bottom: 5px;
`;